



























































































































































  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { SelectAutocomplete } from '@/commun/components/champ-formulaire/select-autocomplete';
  import SelectAutocompleteItem from '@/commun/components/champ-formulaire/select-autocomplete/select-autocomplete-item';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import Faculte from '@/commun/services/set/model/faculte';
  import Matiere from '@/commun/services/set/model/matiere';
  import Session from '@/commun/services/set/model/session';
  import Unite, {
    CODE_AUCUNE_FACULTE_DESIGNEE,
    CODE_NON_UTILISE,
    TypeUnite,
  } from '@/commun/services/set/model/unites';
  import CourrielTextfield from '@/components/faculte/demandes/formulaires/champs/courriel-textfield/courriel-textfield.vue';
  import { SerieCoursSelect } from '@/components/faculte/demandes/formulaires/champs/information-base-cours/serie-cours';
  import { TitreCoursTextfield } from '@/components/faculte/demandes/formulaires/champs/information-base-cours/titre-cours';
  import { SectionFormulaireCours } from '@/components/faculte/demandes/formulaires/creation-cours/section-formulaire-cours';
  import { ChampsInformationBase } from '@/components/faculte/demandes/formulaires/creation-cours/section-information-base/champs-information-base';
  import Vue, { PropType } from 'vue';
  import { IdentiteRoles } from '@/domain/models/identite';
  import DemandeCours from '@/domain/models/demande-cours';

  export default Vue.extend({
    name: 'SectionInformationBase',
    components: {
      ChampFormulaire,
      CourrielTextfield,
      SelectAutocomplete,
      SerieCoursSelect,
      TitreCoursTextfield,
      Tooltip,
    },
    mixins: [SectionFormulaireCours],
    props: {
      champsAffiches: {
        type: Array as PropType<Array<ChampsInformationBase>>,
        default: () => Object.values(ChampsInformationBase),
      },
      unitesResponsables: {
        type: Array as PropType<Array<Unite>>,
        required: true,
      },
      facultes: {
        type: Array as PropType<Array<Faculte>>,
        required: true,
      },
      matieres: {
        type: Array,
        required: true,
      },
      sessionCourante: {
        type: Object as PropType<Session>,
        required: true,
      },
      facultesRattachement: {
        type: Array as PropType<Array<string>>,
        required: true,
      },
      roles: {
        type: Array as PropType<Array<IdentiteRoles>>,
        required: true,
      },
      setDefaultValueUnites: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      maximumCaracteresTitreCours: 60,
      maximumCaracteresDescriptionCours: 800,
      maximumCaracteresCourrielDirecteur: 320,
      maximumCaracteresCourrielApprobateurFacultaire: 320,
      champsInformationBase: ChampsInformationBase,
      demandeCourante: {} as DemandeCours,
    }),
    computed: {
      facultesItems(): SelectAutocompleteItem[] {
        return (this.facultes as Faculte[])
          .filter(
            (faculte: Faculte) =>
              (this.roles.includes(IdentiteRoles.GESTIONNAIRE) ||
                this.facultesRattachement.includes(
                  faculte.codeUnitePedagogique
                )) &&
              faculte.affichableDansListeDeValeurs &&
              faculte.codeUnitePedagogique !== CODE_NON_UTILISE &&
              faculte.codeUnitePedagogique !== CODE_AUCUNE_FACULTE_DESIGNEE
          )
          .map((faculte: Faculte) => ({
            texte: faculte.obtenirNomAffichage(),
            valeur: faculte.codeUnitePedagogique,
          }));
      },
      matieresItems(): SelectAutocompleteItem[] {
        return (this.matieres as Matiere[]).map((matiere: Matiere) => ({
          texte: `${matiere.sigleMatiere} - ${matiere.description}`,
          valeur: matiere.sigleMatiere,
        }));
      },
      sessionCouranteFormatee(): string {
        return `${this.sessionCourante.codeSession} - ${this.sessionCourante.description}`;
      },
      unitesResponsablesValides(): Unite[] {
        return this.unitesResponsables.filter(
          (unite: Unite) =>
            (this.roles.includes(IdentiteRoles.GESTIONNAIRE) ||
              this.facultesRattachement.includes(
                unite.codeUnitePedagogiqueMere
              )) &&
            unite.affichableDansListeDeValeurs &&
            unite.type === TypeUnite.DEPARTEMENT &&
            unite.codeUnitePedagogiqueMere !== CODE_AUCUNE_FACULTE_DESIGNEE &&
            unite.codeUnitePedagogiqueMere !== CODE_NON_UTILISE
        );
      },
      unitesResponsablesItems(): SelectAutocompleteItem[] {
        if (!this.unitesResponsablesValides) {
          return [];
        }
        return this.unitesResponsablesValides.slice().map((unite: Unite) => ({
          texte: `${unite.codeUnitePedagogique} - ${unite.nomUnitePedagogique}`,
          valeur: unite.codeUnitePedagogique,
        }));
      },
    },
    methods: {
      afficherChamp(champ: ChampsInformationBase): boolean {
        return this.champsAffiches?.some(
          (champAffiche) => champ === champAffiche
        );
      },
      onChangementFaculte(faculte: Unite): void {
        this.$emit('changementFaculte', faculte);
      },
    },
  });
